import React, { useState } from 'react';
import { Box, Text, PopoverMenu, TextButton } from '@wix/design-system';
import { ChevronDown, ChevronUp } from '@wix/wix-ui-icons-common';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { communityNavSubHeaderDataHooks } from '../CommunityNavSubHeader.dataHooks';
import {
  COMMUNITY_NAV_DROPDOWN_OPTIONS,
  DROPDOWN_IDS,
  DropdownId,
} from '../navSubHeaderUtils';
import DiscordButton from '../DiscordButton';

interface Props {
  className?: string;
}

const CommunityNavSubHeaderDesktop = ({ className }: Props) => {
  const { t } = useTranslation();
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);

  const renderDropdown = (id: DropdownId) => {
    const labelKey = `marketplace.community-nav-sub-header.${id}`;
    const isOpen = openDropdown === id;
    const options = COMMUNITY_NAV_DROPDOWN_OPTIONS[id];

    return (
      <PopoverMenu
        key={id}
        appendTo="viewport"
        placement="bottom-start"
        dataHook={communityNavSubHeaderDataHooks.dropdown({ id })}
        onHide={() => setOpenDropdown(null)}
        onShow={() => setOpenDropdown(id)}
        showArrow={false}
        minWidth="220px"
        textSize="small"
        triggerElement={
          <TextButton
            as="button"
            skin="dark"
            size="medium"
            weight={isOpen ? 'bold' : 'thin'}
            suffixIcon={isOpen ? <ChevronUp /> : <ChevronDown />}
            dataHook={communityNavSubHeaderDataHooks.trigger({ id })}
          >
            {t(labelKey)}
          </TextButton>
        }
      >
        {options.map((option) => (
          <PopoverMenu.MenuItem
            key={option.hrefKey}
            text={t(option.labelKey)}
            onClick={() => {
              window.open(t(option.hrefKey), '_blank');
            }}
            skin="dark"
          />
        ))}
      </PopoverMenu>
    );
  };

  return (
    <header
      data-hook={communityNavSubHeaderDataHooks.root()}
      style={{ overflow: 'hidden' }}
      className={className ?? ''}
    >
      <Box
        direction="horizontal"
        align="space-between"
        verticalAlign="middle"
        padding="12px SP6"
        dataHook={communityNavSubHeaderDataHooks.root()}
      >
        <Text
          size="medium"
          weight="normal"
          dataHook={communityNavSubHeaderDataHooks.title()}
        >
          {t('marketplace.community-nav-sub-header.title')}
        </Text>
        <Box direction="horizontal" verticalAlign="middle" gap="30px">
          {DROPDOWN_IDS.map(renderDropdown)}
          <DiscordButton />
        </Box>
      </Box>
    </header>
  );
};

export default CommunityNavSubHeaderDesktop;
